import React from 'react';

export function Spinner() {
    return (
        <div className="spinner">
            Loading...
        </div>
    );
}
